module.exports = __webpack_public_path__ + "media/images/external_email_banner-f1b6b7b2bede1719fe537cf65a3386d9.png";